module.exports = __webpack_public_path__ + "static/img/05_name.568f9af.png";